import { Injectable } from '@angular/core';
import { FormControlServiceBase } from '../types/form-control-service.base';

@Injectable({
  providedIn: 'root'
})
export class CheckboxFormControlService implements FormControlServiceBase<'checkbox'> {

  constructor() { }
}
